<template>
  <div class="cpsjj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">最新数据集</div>
          <div class="t22">
            根据市场需求，定期推出新数据集，为您的AI项目快速启动提供助力。
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <!-- <div class="title">成功案例</div> -->
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">最新数据集</div>
            <div style="line-height: 1.5;font-size: 18px;">
              我们的高质量数据集可帮助您快速启动AI项目。
            </div>
            <div style="line-height: 1.5;font-size: 18px;margin-bottom: 48px;">
              提供700+个成品数据集，其中包括五万余小时ASR语音数据，一百六十万余张图片，81亿token、千万词条的大语言模型相关的文本数据集。我们成品数据集旨在有效提高准确性和整体性能，并为特定的AI项目需求快速提供大规模的高质量数据集。我们也在不断构建新的数据集，以满足我们全球客户群的需求。
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjj/e2.webp"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">大语言模型数据集</div>
      <div class="slogan">
        针对大语言模型的基础模型训练、模型微调、以及应用落地需求，提供超过290种语言和方言的相关文本、语音数据库，并创建了一系列LLM专用的数据集。同时，我们也有LLM全链路服务及大模型开发平台，帮助企业轻松拥抱大模型。
        </div>
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;align-items: stretch;">
          <div class="card-sx" style="width: 600px;" v-for="(item, index) in cardList3" :key="index">
            <div class="contents">
              <div class="img-sx">
              <!-- <img style="width: 48px;height: 48px;margin-bottom: 12px;" :src="item.img" alt="" /> -->
            </div>
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
              <!-- <div style="color: #045588;margin-top: 48px;">获取数据集</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">学科类数据集</div>
      <div class="slogan">
        教育大模型训练需要从大量的学科文本库中汲取不同的知识内容。高质量的知识点掌握和解题技能对于最终训练出的模型质量至关重要。我们多学科题目数据库涵盖多学科试题数据，并通过多重环节严格把关数据质量，助力教育大模型训练和落地。
        </div>
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;align-items: stretch;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <div class="contents">
              <div class="img-sx">
              <!-- <img style="width: 48px;height: 48px;margin-bottom: 12px;" :src="item.img" alt="" /> -->
            </div>
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
              <!-- <div style="color: #045588;margin-top: 48px;">获取数据集</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">小语种数据集</div>
      <div class="slogan">
        提供全球59个国家的64种语言的成品数据集，包括文本、音频、OCR图像、视频数据以及发音词典等。以下列出一些较为经典的语言类别。联系我们获得全部小语种数据集列表以及样例。
        </div>
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;align-items: stretch;" >
          <div class="card-sx" v-for="(item, index) in cardList2" :key="index" :style="index==8?'opacity: 0;':''">
            <div class="contents">
              <div class="img-sx">
              <!-- <img style="width: 48px;height: 48px;margin-bottom: 12px;" :src="item.img" alt="" /> -->
            </div>
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
              <!-- <div style="color: #045588;margin-top: 48px;">获取数据集</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <!-- <div class="title">成功案例</div> -->
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjj/e3.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">数据采集服务</div>
            <div style="line-height: 1.5;font-size: 18px;margin-bottom: 48px;">
              我们的数据采集服务可单独提供，也可作为多个交付成果的一部分提供，例如ASR语音数据库，该数据库通常包括音频数据、转录、发音词典和特定语言的文档或带标注的图像数据集。我们的数据采集服务涵盖各种环境的各种数据类型和采集方法，满足您针对特定场景的数据需求。
            </div>
            <div class="btn1" @click="go('/callMe')">了解我们数据采集服务</div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="t1">高效部署模型</div>
      <div class="t2">700+数据集支持您快速高效部署AI模型</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList: [
        {
          name: "快速部署",
          content:
            "直接获取数据库产品快速为您部署AI与机器学习项目",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "低成本高效益",
          content:
            "直接获取经授权的成品数据库比您定制数据采集服务更具成本效益。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "专家团队",
          content:
            "您将拥有一支在数据采集领域耕耘近三十年的专家团队支持",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "支持所有数据类型",
          content:
            "图像，视频，语音，音频，文本",
          img: require("../assets/img/sjfw/e4.svg"),
        },
        {
          name: "大规模",
          content:
            "提供大量、高品质的数据高效地训练您的机器模型",
          img: require("../assets/img/sjfw/e4.svg"),
        },
        {
          name: "高质量",
          content:
            "提高您的机器模型质量并减少数据偏见",
          img: require("../assets/img/sjfw/e4.svg"),
        },
      ],
      cardList11: [
        {
          title: "安全驾驶/自动驾驶",
          img: require("../assets/img/sjj/w1.webp"),
          textList: [
            {
              title: "驾驶人危险行为识别数据库",
              content: "助力驾驶舱内检测驾驶位、驾驶员危险动作以及疲劳识别",
            },
            {
              title: "乘客安全监测数据库",
              content: "，助力识别被遗留的小孩、宠物、危害物品等",
            },
            {
              title: "车载语音数据库",
              content: "助力驾驶人实现语音导航、多元化智能驾驶体验",
            },
            {
              title: "驾驶舱外数据库",
              content: "助力道路车道线、障碍物、停车位识别",
            },
          ],
        },
        {
          title: "互联网虚拟人/智能客服",
          img: require("../assets/img/sjj/w2.webp"),
          textList: [
            {
              title: "线上NLP多轮对话的数据集",
              content: "助力实现生成类AI聊天程序，实现线上客服智能化",
            },
            {
              title: "TTS语音数据库",
              content:
                "对文本文件进行实时转换，把文本智能地转化为自然语音流，文本输出的语音音律流畅，使得听者在听取信息时感觉自然",
            },
          ],
        },
        {
          title: "智慧金融",
          img: require("../assets/img/sjj/w3.webp"),
          textList: [
            {
              title: "我们的金融 OCR 数据集",
              content:
                "可针对金融、保险的合同审核自动化，助力实现高效、精准的文本转写识别自动化",
            },
          ],
        },
        {
          title: "智能家居",
          img: require("../assets/img/sjj/w4.webp"),
          textList: [
            {
              title: "语音识别数据库",
              content:
                "，支持智能家居AI的智能交互",
            },
            {
              title: "障碍物图像数据库，",
              content:
                "助力例如扫地机器人的智能识别和障碍物跨越",
            },
          ],
        },
        {
          title: "智能终端",
          img: require("../assets/img/sjj/w5.webp"),
          textList: [
            {
              title: "人脸识别，语音识别",
              content:
                "等数据集可以助您部署智能终端",
            },
          ],
        },
        {
          title: "智能安防",
          img: require("../assets/img/sjj/w6.webp"),
          textList: [
            {
              title: "人脸识别，危险动作追踪等数据集",
              content:
                "可助您搭建智能安防人工智能",
            }
          ],
        },
      ],
    cardList3: [
        {
          title: "LLM双人中文对话语料",
          img: require("../assets/img/sjj/q1.svg"),
          textList: [
            {
              title: "",
              content:
                "LLM中文对话语料数据集，话题包括日常对话、科技、体育、以及医疗等，支持您的中文大语言模型微调需求。",
            }
          ],
        },
        {
          title: "知识类百科文本语料对",
          img: require("../assets/img/sjj/q2.svg"),
          textList: [
            {
              title: "",
              content:
                "中文知识类百科文本语料对涵盖了多方面的中文环境的知识、常识、以及事实说明，支持多种基础模型的中文微调。",
            },
          ],
        },
        {
          title: "法律问答数据集",
          img: require("../assets/img/sjj/q3.svg"),
          textList: [
            {
              title: "",
              content: "中文法律问答数据集汇合了26000对法律类的问答数据，内容全面、涵盖法学的主要话题，支持法律方面微调需求。",
            }
          ],
        },
        {
          title: "医疗问答数据集",
          img: require("../assets/img/sjj/q4.svg"),
          textList: [
            {
              title: "",
              content: "中文医疗问答数据集包括226000对医疗相关知识语料对，涵盖常见的医疗常识、中文医疗用语等，支持大语言模型的医疗问答微调。",
            }
          ],
        }
      ],
      cardList1: [
        {
          name: "数据存储与传输",
          list: [
            { t: "国安级加密云技术保证数据传输和存储安全" },
            {
              t:
                "业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
          ],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
          list: [
            { t: "项目现场配置人脸识别和指纹门禁" },
            {
              t:
                "设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别",
            },
            { t: "配有24*7值班人员以及无死角摄像头监控现场" },
          ],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list: [
            { t: "标注人员及供应商签署保密协议" },
            { t: "全体员工办公设备均统一管理" },
          ],
          img: require("../assets/img/sjfw/x3.svg"),
        },
      ],
      cardList2: [
        {
          title: "阿拉伯语",
          img: require("../assets/img/sjj/q1.svg"),
          textList: [
            {
              title: "",
              content:
                "我们的阿拉伯语资源丰富，包括阿拉伯语在阿尔及利亚、阿拉伯联合酋长国、埃及、沙特阿拉伯、摩洛哥和突尼斯的发音词典，对话语料库，可以针对相关国家口音进行全面训练。",
            }
          ],
        },
        {
          title: "德语",
          img: require("../assets/img/sjj/q2.svg"),
          textList: [
            {
              title: "",
              content:
                "我们的德语资源包括发音词典、麦克风录音、电话录音语料库、自由说语音库、以及OCR图片数据库，涵盖德国、卢森堡、瑞士以及土耳其四个国家的德语数据，支持针对地区口音进行训练。",
            },
          ],
        },
        {
          title: "法语",
          img: require("../assets/img/sjj/q3.svg"),
          textList: [
            {
              title: "",
              content: "我们的法语资源包括法国、加拿大、卢森堡、比利时和阿尔及利亚五个国家的不同口音的数据集，包括发音词典、词性词典、电话录音、反向文本规范化、自由说语音数据库以及OCR图片数据。",
            }
          ],
        },
        {
          title: "俄语",
          img: require("../assets/img/sjj/q4.svg"),
          textList: [
            {
              title: "",
              content: "我们的俄语数据集包含发音词典、词性词典、自由说语音数据集、NER语料库、麦克风和电话录音、新闻文本NER、以及女声TTS数据集，支持AI对俄语的本地化。",
            }
          ],
        },
        {
          title: "西班牙语",
          img: require("../assets/img/sjj/q5.svg"),
          textList: [
            {
              title: "",
              content: "我们的西班牙语资源涵盖西班牙以及美洲的七个国家（阿根廷、哥伦比亚、美国、秘鲁、委内瑞拉和智利）的不同口音资源，包括发音词典、麦克风/电话录音数据、自由说长语音、以及OCR图片数据。",
            }
          ],
        },
        {
          title: "葡萄牙语",
          img: require("../assets/img/sjj/q6.svg"),
          textList: [
            {
              title: "",
              content: "我们的葡萄牙语资源包括葡萄牙、欧洲以及巴西的多种口音的发音词典、词性词典、电话和麦克风录音、以及图片OCR数据集，支持对葡萄牙和巴西的单独训练和优化。+国家资深声优资源库",
            }
          ],
        },
        {
          title: "荷兰语",
          img: require("../assets/img/sjj/q6.svg"),
          textList: [
            {
              title: "",
              content: "我们的荷兰语资源包括荷兰和比利时两个国家的不同口音数据集、发音词典、电话录音、麦克风录音数据集，支持对荷兰和比利时的口音进行训练。+国家资深声优资源库",
            }
          ],
        },
        {
          title: "日语",
          img: require("../assets/img/sjj/q6.svg"),
          textList: [
            {
              title: "",
              content: "我们的日语资源全面，包括词性词典、发音词典、麦克风录音、多人商务/日常对话录音、NER语料库、OCR发票数据集等，支持AI的日本市场本地化。+国家资深声优资源库",
            }
          ],
        },
        {
          title: "",
          img: require("../assets/img/sjj/q6.svg"),
          textList: [
            {
              title: "",
              content: "",
            }
          ],
        },
      ],
      cardList: [
        {
          title: "初高中语文题OCR学科数据集",
          img: require("../assets/img/sjj/q1.svg"),
          textList: [
            {
              title: "",
              content:
                "量级：40,000题",
            },
            {
              title: "",
              content:
                "题型：单选、复合（考察考生的鉴赏评价等能力）、填空、解答（考察考生大作文/表达应用等能力）",
            },
            {
              title: "",
              content:
                "涵盖知识点：常识、名著阅读、诗歌鉴赏、语言运用等+小时",
            }
          ],
        },
        {
          title: "初高中生物OCR学科数据集",
          img: require("../assets/img/sjj/q2.svg"),
          textList: [
            {
              title: "",
              content:
                "量级：40,000题",
            },
            {
              title: "",
              content:
                "题型：单选、多选、复合（考察考生计算能力）、填空、解答（考察考生推理判断及化学思维的综合运用能力）",
            },
            {
              title: "",
              content:
                "涵盖知识点：物质结构与性质、反应原理综合、有机化学、无机化学、定性和定量思想等",
            }
          ],
        },
        {
          title: "小学初中高中数学题",
          img: require("../assets/img/sjj/q3.svg"),
          textList: [
            {
              title: "",
              content: "量级：30,000题",
            },
            {
              title: "",
              content: "题型：单选（考察考生在正确判断考点基础上的速算能力）",
            },
            {
              title: "",
              content: "涵盖知识点：平面几何、立体几何、数列矩阵、代数式、综合应用等",
            }
          ],
        },
        {
          title: "行业书籍杂志OCR数据集",
          img: require("../assets/img/sjj/q4.svg"),
          textList: [
            {
              title: "",
              content: "本数据集涵盖超过七千张行业书籍杂志的图像OCR数据，包括多专业、多类别的话题，以及表格数据。数据场景包括文档拍照（纸质文档、电子文档）、文档扫描件、电子文档原件图像或截图。",
            }
          ],
        },
        {
          title: "教育教辅综合OCR数据集",
          img: require("../assets/img/sjj/q5.svg"),
          textList: [
            {
              title: "",
              content: "本数据集涵盖超过一万张教育教辅材料的图像OCR数据，包括多专业、多类别的话题，以及表格数据。数据场景包括文档拍照（纸质文档、电子文档）、文档扫描件、电子文档原件图像或截图。",
            }
          ],
        },
        {
          title: "公开财务报表OCR数据集",
          img: require("../assets/img/sjj/q6.svg"),
          textList: [
            {
              title: "",
              content: "本数据集涵盖近千份公开财务报表数据，以常规表格数据为主，具体分为有线表、少线表和无线表。通用表格场景为文档拍照（纸质文档、电子文档）、文档扫描件、电子文档原件图像或截图。+国家资深声优资源库",
            }
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.cpsjj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 370px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2 {
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card22 {
    width: 1280px;
    margin: 0 auto;
    .card-ys{
      width:448px;
      height:178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top:24px;
      .t1{
        font-size:20px;
        color: #25282a;
        margin-bottom: 16px;
      }.t2{
        font-size:16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 405px;
      margin: 0 0 48px;
      background-color: #eceff0;
      .contents {
        padding: 24px;
        // height: 328px;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 24px;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys {
      width: 355px;
      height: 178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top: 24px;
      .t1 {
        font-size: 20px;
        color: #25282a;
        margin-bottom: 16px;
      }
      .t2 {
        font-size: 16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 400px;
      margin: 0 0 48px;
      background-color: #eceff0;
      border-radius: 16px;
      .contents {
        padding: 24px;
        // height: 420px;
        border-radius: 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2 {
      font-size: 16px;
      line-height: 1.5;
    }
    .title-11{
      font-size: 28px;
      color: #444;
      line-height: 2;
      font-weight: 600;
    }
    .title-22{
      font-size: 16px;
      color: #4b4f54;
      line-height: 1.5;
      margin-bottom: 16px;
    }
    li {
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
